import styled from "styled-components";

export const Section = styled.div`
  width: 100%;
  padding: 20px 20px;
`;

export const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr; /* 2 colunas */
  gap: 16px; /* espaço entre colunas e linhas */
  padding: 50px 100px;
  @media (max-width: 768px) {
    grid-template-columns: 1fr; /* em telas pequenas vira 1 coluna */
    padding: 0px 0px;
  }
`;

export const InfoRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const InfoRowPlan = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  gap: 16px;
  padding: 20px;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 20px 20px;
`;

export const KeyValue = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  min-width: 0;
`;

export const Key = styled.div`
  font-weight: bold;
  margin-right: 8px;
`;

export const Value = styled.div`
  color: #333;
`;
export const Title = styled.h5`
  font-size: 1.25rem;
  font-weight: bold;
  color: #333;
  margin-bottom: 1rem;
`;

export const CenterRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const SubTitle = styled.h5`
  font-size: 1rem;
  font-weight: bold;
  color: #333;
  margin-bottom: 1rem;
`;
